var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "md-layout",
    { attrs: { "md-flex": "100" } },
    [
      _c("div", { staticClass: "md-headline" }, [_vm._v("Subtitles")]),
      _vm.anyRowLoading
        ? _c("loader", { attrs: { loading: true, size: 40 } })
        : _vm._e(),
      _c(
        "md-layout",
        { staticClass: "new-subtitle-row", attrs: { "md-flex": "100" } },
        _vm._l(_vm.formRows, function(row, index) {
          return _c(
            "md-layout",
            {
              key: "form-" + index,
              staticClass: "subtitle-row",
              attrs: { "md-flex": "100" }
            },
            [
              _c(
                "md-layout",
                { staticClass: "options flex-grow-0" },
                [
                  _vm.anyRowLoading
                    ? _c("md-select", {
                        key: "select-disabled",
                        attrs: {
                          placeholder: "Select language",
                          disabled: "disabled"
                        },
                        model: {
                          value: row.language,
                          callback: function($$v) {
                            _vm.$set(row, "language", $$v)
                          },
                          expression: "row.language"
                        }
                      })
                    : _c(
                        "md-select",
                        {
                          key: "select-enabled",
                          attrs: { placeholder: "Select language" },
                          model: {
                            value: row.language,
                            callback: function($$v) {
                              _vm.$set(row, "language", $$v)
                            },
                            expression: "row.language"
                          }
                        },
                        _vm._l(_vm.languagesForRow(index), function(language) {
                          return _c(
                            "md-option",
                            {
                              key: language.code,
                              attrs: { value: language.code }
                            },
                            [_vm._v(_vm._s(language.name))]
                          )
                        }),
                        1
                      )
                ],
                1
              ),
              _c(
                "md-layout",
                [
                  _c(
                    "md-input-container",
                    [
                      _c("label", [_vm._v("Select .srt file to upload")]),
                      _c("md-file", {
                        key:
                          "file-input-" +
                          index +
                          "-" +
                          _vm.fileInputResetKeys[index],
                        attrs: {
                          type: "file",
                          accept: ".srt",
                          disabled: _vm.anyRowLoading || !row.language
                        },
                        on: {
                          selected: function($event) {
                            return _vm.onFileSelected($event, index)
                          }
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        }),
        1
      ),
      _vm.isEditMode && _vm.changeProp
        ? _c(
            "div",
            { staticClass: "container-info" },
            [
              _c("md-icon", {
                staticClass: "icon-info",
                attrs: { "md-iconset": "fa fa-info" }
              }),
              _c("p", { staticClass: "check-properties" }, [
                _vm._v("Changes will be applied when you click update.")
              ])
            ],
            1
          )
        : _vm._e(),
      _c(
        "div",
        { staticClass: "subtitles-section" },
        _vm._l(_vm.subtitlesProp, function(subtitle, index) {
          return _c(
            "md-layout",
            {
              key: "uploaded-" + index,
              staticClass: "subtitle-row",
              attrs: { "md-flex": "100" }
            },
            [
              _c(
                "md-layout",
                { staticClass: "options flex-grow-0" },
                [
                  _c(
                    "md-select",
                    {
                      attrs: {
                        value: subtitle.language,
                        disabled: "disabled",
                        placeholder: "Language"
                      }
                    },
                    _vm._l(_vm.availableLanguages, function(language) {
                      return _c(
                        "md-option",
                        { key: language.code, attrs: { value: language.code } },
                        [_vm._v(_vm._s(language.name))]
                      )
                    }),
                    1
                  )
                ],
                1
              ),
              _c("md-layout", [
                _c("span", { staticClass: "subtitle-link" }, [
                  _c(
                    "a",
                    {
                      attrs: {
                        href:
                          "//" + _vm.subtitleBucketName + "/" + subtitle.path,
                        target: "_blank",
                        rel: "noopener noreferrer"
                      }
                    },
                    [_vm._v(_vm._s(subtitle.path.split("/").pop()))]
                  )
                ])
              ]),
              _c(
                "md-layout",
                { staticClass: "row-actions flex-grow-0" },
                [
                  _c(
                    "md-button",
                    {
                      staticClass: "md-icon-button md-primary",
                      on: {
                        click: function($event) {
                          return _vm.deleteUploadedRow(subtitle)
                        }
                      }
                    },
                    [
                      _c("md-icon", {
                        staticClass: "icon",
                        attrs: { "md-iconset": "fa fa-trash" }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        }),
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-a6479b0c", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a6479b0c","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug&optionsId=0!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/shared-components/upload/SubtitleUploader.vue
// module id = 969
// module chunks = 0